import { api } from '@/infra/axios';

export const npmModuleVersions = async (moduleId) => {
  return api.get(`/npm/${moduleId}/versions`);
};
